module.exports = __webpack_public_path__ + "img/moban_banner_h5.30e552d4.png";